import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/sup-groups'
  })

const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/sup-groups/${data.id}`,
    data
  })

  const modifyTrees = data =>
  baseApi.request({
    method: 'patch',
    url: '/sup-groups/trees',
    data
  })

  const createOne = data =>
    baseApi.request({
      method: 'post',
      url: '/sup-groups',
      data
    })

const deleteAll = data =>
  baseApi.request({
    method: 'delete',
    url: '/sup-groups',
    data
  })

const fetchGroupUsers = params =>
  baseApi.request({
    method: 'get',
    url: `/sup-groups/${params.id}/users`,
    params
  })

const addGroupUsers = data =>
  baseApi.request({
    method: 'post',
    url: `/sup-groups/${data.id}/users`,
    data
  })

const deleteGroupUsers = data =>
  baseApi.request({
    method: 'delete',
    url: `/sup-groups/${data.id}/users`,
    data
  })

const downloadSupGroupTemplate = () =>
  baseApi.request({
    method: 'get',
    url: '/sup-groups/download-template',
    responseType: 'blob'
  });

const uploadSupGroups = data =>
  baseApi.request({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: '/sup-groups/upload',
    responseType: 'blob',
    data
  });

export {
  fetchAll,
  modifyOne,
  modifyTrees,
  createOne,
  deleteAll,
  fetchGroupUsers,
  addGroupUsers,
  deleteGroupUsers,
  downloadSupGroupTemplate,
  uploadSupGroups
}


// WEBPACK FOOTER //
// ./src/api/supGroup.js